exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overdue_day_input[data-v-17d43626]{border-radius:4px;border:1px solid #dcdfe6}.overdue_day_input[data-v-17d43626] .el-input__inner{border:none}\n", ""]);

// exports
